import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class ChequesTemplatesService {

  private service_url: string;
  private api_url: string;
  private module_url: string;

  constructor( private http: Http,
               private constantsServices: ConstantsService,
               private validatorService: ValidatorService,
               private errorService: ErrorsService,
               private authService: AutenticacionService) {
      //this.api_url = constantsServices.apiURL;
      this.api_url = constantsServices.apiURL;
      this.module_url = '/movimientos/cheques_template';
      this.service_url = this.api_url + this.module_url;
  }

  public createTemplate(data) {

      return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  public updateTemplate(data, id) {
    return this.http.put(this.service_url + '?id=' + id, data, this.authService.getAuthHeaders());
  }


  public getTemplates() {
    return this.http.get(this.service_url, this.authService.getAuthHeaders());
  }

  public deleteTemplate(id) {
    return this.http.delete(this.service_url + '?id=' + id, this.authService.getAuthHeaders());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/cheques-templates.service.ts